"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setUserMarginNotifications = exports.marginNotificationsReducer = exports.getUserMarginNotifications = exports.getMarginNotificationsFromStorage = void 0;
var _snackbarActions = require("../../actions/snackbarActions");
var _dateHelper = require("../../../helpers/dateHelper");
var _actionTypes = require("../actionTypes");
var _userActions = require("../../actions/userActions");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
// Single localStorage key for all users' margin notifications
var MARGIN_NOTIFICATIONS_KEY = 'marginNotifications';

// Helper functions to manage user-specific margin notifications in single localStorage object.
// The schema is an object keyed by userId. Older builds stored a top-level array under the same
// key; if we see a non-object (array, primitive, null), discard it so callers always get the
// expected shape and downstream `state.concat` / `Object[userId]` reads don't blow up.
var getMarginNotificationsFromStorage = exports.getMarginNotificationsFromStorage = function getMarginNotificationsFromStorage() {
  try {
    var stored = localStorage.getItem(MARGIN_NOTIFICATIONS_KEY);
    if (!stored) return {};
    var parsed = JSON.parse(stored);
    if (!parsed || _typeof(parsed) !== 'object' || Array.isArray(parsed)) {
      localStorage.removeItem(MARGIN_NOTIFICATIONS_KEY);
      return {};
    }
    return parsed;
  } catch (error) {
    console.error('Error reading marginNotifications from localStorage', error);
    return {};
  }
};
var getUserMarginNotifications = exports.getUserMarginNotifications = function getUserMarginNotifications(userId) {
  var allNotifications = getMarginNotificationsFromStorage();
  return allNotifications[userId] || [];
};
var setUserMarginNotifications = exports.setUserMarginNotifications = function setUserMarginNotifications(userId, notifications) {
  try {
    var allNotifications = getMarginNotificationsFromStorage();
    allNotifications[userId] = notifications;
    localStorage.setItem(MARGIN_NOTIFICATIONS_KEY, JSON.stringify(allNotifications));
  } catch (error) {
    console.error('Error saving marginNotifications to localStorage', error);
  }
};

// Initialize with empty state - will load user-specific notifications after login
var initialState = [];
var snackIds = ['MarginOrderLiquidation', 'MarginCall', 'MarginPositionLiquidation', 'MarginCancelOrderAccountLiquidation'];
var marginNotificationsReducer = exports.marginNotificationsReducer = function marginNotificationsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments.length > 1 ? arguments[1] : undefined,
    type = _ref.type,
    payload = _ref.payload;
  switch (type) {
    case _userActions.USER_INFO_FETCHED:
      // Load user-specific notifications from localStorage when user logs in
      if (payload.UserId) {
        return getUserMarginNotifications(payload.UserId);
      }
      return state;
    case _snackbarActions.ADD_SNACK:
      if (snackIds.includes(payload.id) && !state.some(function (item) {
        return item.id === getUniqueKey(payload);
      })) {
        var dateTime = new Date(payload.uniqueId);
        var formattedDateTime = (0, _dateHelper.formatDate)(dateTime, 'HH:mm - M/d/yyyy');
        return state.concat({
          id: getUniqueKey(payload),
          type: payload.id,
          data: payload.textVars,
          dateTime: formattedDateTime
        });
      }
      return state;
    case _actionTypes.DISMISS_MARGIN_NOTIFICATION:
      return state.filter(function (item) {
        return item.id !== payload;
      });
    default:
      return state;
  }
};
function getUniqueKey(snack) {
  switch (snack.id) {
    case 'MarginOrderLiquidation':
      return "MarginOrderLiquidation-".concat(snack.textVars.InstrumentSymbol, "-").concat(snack.textVars.Side);
    case 'MarginPositionLiquidation':
      return "MarginPositionLiquidation-".concat(snack.textVars.PositionId);
    case 'MarginCancelOrderAccountLiquidation':
      return "MarginCancelOrderAccountLiquidation-".concat(snack.textVars.OrderId);
    case 'MarginCall':
      return "MarginCall-".concat(snack.uniqueId);
    default:
      return snack.id;
  }
}